import { makeRequest } from 'utils/requestLogger';

const getSettings = () =>
  makeRequest('get', '/api/roundtable_welcome_settings').then(
    (resp) => resp.data
  );

const getSettingsByQuery = (query) =>
  makeRequest(
    'get',
    `/api/roundtable_welcome_settings${
      query ? '?roundtable_type=' + query : ''
    }`
  ).then((resp) => resp.data);

export default {
  getSettings,
  getSettingsByQuery,
};



// WEBPACK FOOTER //
// ./src/app/services/account/getWelcomeSettings.js